export enum CategoryLevel {
  ROOT = 'Root',
  FIRST = 'First'
}
